import { type StepModel } from "../../../models/basics/basics.models";
import { autoinject, computedFrom, observable, useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { Profile } from "./profile";
import { Reflection } from "../../../utilities/reflection";

@autoinject()
@useView('views/pages/settings/my-account.html')
export class MyAccount {

    public title: string;
    constructor(private profile: Profile, private i18N: I18N) {
        this.title = this.i18N.tr('my-profile-text');
    }

    @computedFrom(Reflection.getPropertyPath<MyAccount>(z => z.profile),
        Reflection.getPropertyPath<MyAccount>(z => z.title))
    public get tabs() : StepModel[]
    {
        return  [
            {
                show: () => true,
                title: this.title,
                step: 4,
                vm: this.profile,
                onClick: () => {}
            }
        ];
    }

    @observable
    public currentTab: StepModel = null;

    currentTabChanged(a, b) {
        if (a && a.title != (b ? b.title : '')) {
            this.currentTab ? this.currentTab.onClick(null) : null;
        }
    }
}
